import { useCustomTranslation } from "../../../helpers/translateHelpers";
import GoogleLogo from "../../../assets/google.png";
import MapyComLogo from "../../../assets/mapycom.png";
import { useGetCompanyCustomerInfoQuery } from "../../../common/queries";

const AddressSearchProviderFooter = () => {
  const { tInput } = useCustomTranslation();

  const searchProvider =
    useGetCompanyCustomerInfoQuery().data?.company.addressSearchProvider ??
    "Google";

  return (
    <div className="flex flex-row items-center justify-end px-4">
      <span className="text-secondary mr-2 text-[13px]">
        {tInput("address_search_provider_footer")}
      </span>
      {searchProvider === "Google" ? (
        <img className="max-h-[25px]" src={GoogleLogo} />
      ) : (
        <img className="max-h-[25px]" src={MapyComLogo} />
      )}
    </div>
  );
};

export default AddressSearchProviderFooter;
